module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/close.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/close.png
// module id = 338
// module chunks = 367